const $body = $('body')

export default class ProductZoom {
    #isOpen = false
    #scrollbarWidth;
    #$container;
    #$thumbs;
    #$close;
    #currentImage = 0;
    #options;
    #defaultOptions = {
        duration: 300
    }

    constructor(container, options) {
        this.#$container = $(container);
        this.#scrollbarWidth = window.innerWidth - $body.width();
        this.#options = {...this.#defaultOptions, ...options}
        // Create thumbs
        this.#$thumbs = $(
            '<div class="zoom-thumbs">' +
            this.#$container.find('img').toArray().reduce((acc, img) => {
                acc += '<div class="zoom-thumbs__thumb">' +
                    `<img src="${img.src}" alt="${img.alt}"/>` +
                    '</div>';
                return acc
            }, '') +
            '</div>'
        )
            .appendTo('body')

        const _this = this;

        // thumbs click
        this.#$thumbs.children().click(function () {
            const active = _this.#$container.find('.product__image').eq($(this).index()).get(0)
            const {top, height} = active.getBoundingClientRect()
            _this.#$container.animate({
                scrollTop: _this.#$container.scrollTop() + top + height / 2 - window.innerHeight / 2
            })
        })

        // Close btn
        this.#$close = $('<div class="zoom-close"/>').appendTo('body')
        this.#$close.click(() => {
            this.close(this.#$container.find('.product__image ').eq(this.#currentImage)[0])
        })

        // open click
        this.#$container.find('.product__image').on('click.trigger', function () {
            !_this.#isOpen && _this.open(this)
        })

        // scroll
        this.#$container[0].addEventListener('scroll', this.#onScroll.bind(this))
    }

    destroy() {
        if(this.#isOpen) {
            // Restore scroll container
            this.#$container.removeClass('zoomed')
            this.#showScrollbar()
        }
        this.#$thumbs.remove();
        this.#$close.remove();
        this.#$container.find('.product__image').off('click.trigger')
        this.#$container[0].removeEventListener('scroll', this.#onScroll.bind(this))
    }

    #hideScrollBar() {
        $body.css({
            paddingRight: this.#scrollbarWidth,
            overflow: 'hidden'
        });
        $('#main-header').css({
            paddingRight: this.#scrollbarWidth
        });
    }

    #showScrollbar() {
        $body.css({
            paddingRight: 0,
            overflow: 'auto'
        });
        $('#main-header').css({
            paddingRight: 0
        });
    }

    open(image) {
        this.#currentImage = $(image).index()
        this.#setThumbActive()

        this.#isOpen = true;
        this.#hideScrollBar()

        // Clone clicked image and append place it above the image clicked
        const $clone = $('<div />');
        $clone.append($(image).clone())
        $clone.css({
            left: this.#$container.offset().left,
            top: $(image).offset().top - $(window).scrollTop(),
            position: 'fixed',
            width: this.#$container.width(),
            overflow: 'hidden',
            height: "auto",
            zIndex: 9999,
        }).appendTo("body")

        // Wait for img load and animate it to full width
        $clone.find('img').load(() => {
            $clone.animate({
                width: window.innerWidth - this.#scrollbarWidth,
                top: (window.innerHeight / 2) + (window.innerWidth - this.#scrollbarWidth) * $clone.height() / $clone.width() / 2 * -1,
                left: 0,
            }, this.#defaultOptions.duration, () => {
                this.#$container.addClass('zoomed')
                // Scroll to clicked image
                this.#$container[0].scrollTo({
                    top: image.offsetTop + image.clientHeight / 2 - window.innerHeight / 2,
                    behavior: "instant"
                })
                // Animate thumbs
                this.#$close.addClass('visible')
                this.#$thumbs.addClass('visible')
                setTimeout(() => {
                    $clone.remove()
                }, this.#options.duration)

            })
        })
    }

    close() {

        this.#isOpen = false;
        this.#$close.removeClass('visible')
        this.#$thumbs.removeClass('visible')
        setTimeout(() => {

            // clone active image
            const $clone = $('<div />');
            const $currentImage = this.#$container.find('.product__image').eq(this.#currentImage)

            $clone.append($currentImage.clone())
            $clone.css({
                left: 0,
                top: $currentImage[0].getBoundingClientRect().top,
                position: 'fixed',
                width: window.innerWidth - this.#scrollbarWidth,
                overflow: 'hidden',
                height: "auto",
                zIndex: 9999
            }).appendTo("body")

            // Restore scroll container
            this.#$container.removeClass('zoomed')

            window.scrollTo({
                top: $currentImage.offset().top - parseFloat(window.app.getCustomCSSProperty('header-height')),
                behavior: "instant"
            })

            // Animate cloned image to
            $clone.animate({
                width: this.#$container.width(),
                left: this.#$container.offset().left,
                top: parseFloat(window.app.getCustomCSSProperty('header-height'))
            }, this.#defaultOptions.duration, () => {
                $clone.remove()
            })
            // enable body scroll
            this.#showScrollbar()
        }, this.#options.duration)
    }

    #onScroll() {
        const _this = this;
        const trigger = window.innerHeight / 2
        this.#$container.find('img').each(function (index) {
            const {top} = this.getBoundingClientRect()
            if (trigger >= top) {
                _this.#currentImage = index
            }
        });
        this.#setThumbActive()
    }

    #setThumbActive() {
        const $thumbs = this.#$thumbs.children()
        $thumbs.removeClass('active')
        $thumbs.eq(this.#currentImage).addClass('active')
    }
}